import {Component, OnInit} from '@angular/core';
import {HelperService} from "../services/helper.service";
import {RilrService} from '../services/rilr.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';


@Component({
  selector: 'app-document-audit-modal',
  templateUrl: './document-audit-modal.component.html',
  styleUrls: ['./document-audit-modal.component.scss'],
  providers: [RilrService, NgxSpinnerService, HelperService],
})
export class DocumentAuditModalComponent implements OnInit {

  public reportSystemID: number;
  public documentSystemID: number;
  public master: any = {};
  public accessEmployees = [];
  public accessEmployeesClose = [];
  public reportApprover = [];
  public status: string;
  public loaded: boolean;
  public companySystemID = +this.helperService.getSelectedCompanyId();
  public templateDetail: any = {};

  constructor(private rilrService: RilrService,
              private spinner: NgxSpinnerService,
              private bsModalService: BsModalService,
              private helperService: HelperService,
              private bsModalRef: BsModalRef) {
  }

  ngOnInit() {
    this.templateAssignedRouteView('Dashboard', 0);
    setTimeout(() => {
      if (this.reportSystemID) {
        this.getAudit();
      }
    }, 100);
  }

  public closeModal() {
    this.bsModalRef.hide();
  }

  public templateAssignedRouteView(crudType, reportSystemID) {
    const that = this;
    that.rilrService
      .getTemplateAssignedRoute()
      .get({
        crudType: crudType,
        documentSystemID: 0,
        companySystemID: that.helperService.getSelectedCompanyId()
      })
      .subscribe((output) => {
        const resp = output.data.data;
        that.templateDetail = resp;
      }, () => {
      });
  }

  public getAudit() {
    const that = this;
    that.spinner.show();
    that.rilrService
      .getAllAuditDetails()
      .get({
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID,
      })
      .subscribe(resp => {
        that.spinner.hide();
        that.master = resp.data.data.reportDetail;
        that.accessEmployees = resp.data.data.accessUsers;
        that.accessEmployeesClose = resp.data.data.reportClose;
        that.reportApprover = resp.data.data.reportApprover;
        that.loaded = true;
      }, (error) => {
        that.spinner.hide();
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/document-audit-modal/document-audit-modal.component.ts